<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >

    <!-- // MAINFORM -->
    <b-form id="main">

      <div class="row col-sm-12 mt-2">

          <!-- // MAIN DATAS -->

          <div class="col-sm-2">
            <div class="form-group" hidden>
              <label for="azon">Azonosító</label>
              <b-form-input
                size="sm"
                type="text"
                v-model="azonTemp"
                class="form-control"
                id="azon"
                disabled
              />
            </div>
              <label for="partner">Státusz</label>
              <b-form-select label="Státusz"  v-model="statusSelect" :options="status" size="sm"  id="status"></b-form-select>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label for="kategoria">Partner kat.</label>
              <b-form-select
                size="sm"
                v-if="$route.params.id"
                v-model="partnerkategoriaSelected"
                @change="categoryChange"
                :options="partnerkategoria"
                class="form-control"
                id="kategoria"
                required
                disabled
              ></b-form-select>
              <b-form-select
                size="sm"
                v-if="!$route.params.id"
                v-model="partnerkategoriaSelected"
                @change="categoryChange"
                :options="partnerkategoria"
                class="form-control"
                id="kategoria"
                required
              ></b-form-select>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group" >
              <label for="partner">MiniCRM adatlap neve</label>
              <b-form-input ref="MiniCRM" size="sm" v-model="partner" id="partner" required></b-form-input>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label for="emaillink">MiniCRM adatlap link</label>
              <b-form-input size="sm" v-model="emaillink" id="emaillink" required></b-form-input>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label for="megjegyzes">Megjegyzés</label>
              <textarea v-model="megjegyzes" class="form-control" id="megjegyzes" cols="30" rows="1"></textarea>
            </div>
          </div>
      </div>

    </b-form>

    <!-- // EDITOR SECTION -->
    <div class="row">

      <!-- // NYOMDAI MUNKALAP EDITOR -->
      <div v-show="nyomdaiMunkalapPanelShow" class="col-sm-12 mx-auto" style="bottom: 20px;">
        <b-card
          header="Nyomdai munkalap tételek"
          border-variant="secondary"
          header-bg-variant="secondary"
          header-text-variant="white"
          class="text-center mt-2"
        >
          <!-- <form @submit.stop.prevent="onSubmit"> -->
            <div class="row col-sm-12 mx-auto">
              <form @submit.stop.prevent="savePage">
                <table class="table fluid">
                  <thead>
                    <tr>
                      <th class="text-left">Megnevezés</th>
                      <th>Méret</th>
                      <th>Terjedelem</th>
                      <th>Papír</th>
                      <th>Szín</th>
                      <th>Kötészet</th>
                      <th>Opció</th>
                      <th>Egyéb</th>
                      <th>Mennyiség</th>
                      <th>Darabár</th>
                      <th>Összesen</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.megnevezes" id="megnevezes" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.meret" id="meret" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.terjedelem" id="terjedelem" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.papir" id="papir" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.szin" id="szin" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.koteszet" id="koteszet" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.opciok" id="opciok" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.egyeb" id="egyeb" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.menyiseg" id="menyiseg" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.darabar" id="darabar" required >
                      </td>
                      <td style="width: px;">
                        <input type="text" class="form-control" v-model="myNyomdaiMunkalapTelels.osszesen" id="osszesen" required >
                      </td>
                      <td hidden style="width: 400px;">
                        <select v-model="anyagTipusSelect" class="form-control" id="anyagtipus" >
                          <option v-for="(anyagtipus) in anyagTipus" :key="anyagtipus.id" :value="anyagtipus">
                            {{ anyagtipus.tipus }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <button @click="addElement($event)" class="btn btn-primary mb-2">
                          <b-icon-plus-circle></b-icon-plus-circle>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div hidden>
                    <label for="anyagT">Anyag+kivitel</label>
                    <input type="text" class="form-control" v-model="anyagTipusSelect.tipus" id="anyagT" required>
                </div>
              </form>
            </div>

              <div class="row">

                <!-- // PAGE DETAILS ADD -->
                <div class="col-sm-12 mx-auto">
                  <table class="table mx-auto">
                    <tbody>
                    <tr v-for="(element, index) in myTetels" :key="element.id">
                      <td class="text-left" hidden>{{anyagTipusSelect.tipus}}</td>
                      <td>{{element.tetelnev}}</td>
                      <td>{{element.db}}</td>
                      <td>{{parseFloat(element.cm1, 1).toFixed(1)}}</td>
                      <td>{{parseFloat(element.cm2, 1).toFixed(1)}}</td>
                      <td class="text-right">{{parseFloat(element.m2, 2).toFixed(2)}}</td>
                      <td>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          @click="deleteTetel(myTetels, index)"
                          class="mr-1"
                        ><b-icon-trash></b-icon-trash>
                        </b-button>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colspan="3">Összeterület: </th>
                        <th class="text-right" colspan="2">{{parseFloat(osszterulet, 2).toFixed(2)}}</th>
                      </tr>
                    </tfoot>
                  </table>

                  <!-- SAVE CARD -->
                  <b-button @click="savePage" type="submit" class="btn btn-info mb-2 float-left">
                    <b-icon-cloud-upload></b-icon-cloud-upload>
                    Kártya mentése
                  </b-button>

                  <!-- CANCEL CARD -->
                  <b-button
                    variant="outline-danger"
                    class="float-right"
                    @click="nyomdaiMunkalapPanelShow=false, MunkalapShow=true"
                    ><b-icon-arrow-left></b-icon-arrow-left>
                    Mégsem
                  </b-button>
                </div>

              </div>

        </b-card>
      </div>

      <!-- // PAGE EDITOR -->
      <div v-show="AnyagPanelShow" class="col-sm-9 mx-auto" style="bottom: 20px;">
        <b-card
          header="Munkalap tételek"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
          class="text-center mt-2"
        >
          <!-- <form @submit.stop.prevent="onSubmit"> -->
            <div class="row col-sm-12 mx-auto">
              <form @submit.stop.prevent="savePage">
                <table class="table fluid">
                  <thead>
                    <tr>
                      <th class="text-left">Azonosító (fájlnév)</th>
                      <th>Darab</th>
                      <th>Szélesség (x) cm</th>
                      <th>Magasság (y) cm</th>
                      <th class="text-left">
                        Anyag+kivitel
                        <!-- LEIRÁS MODÁL -->
                        <b-button size="sm" v-show="AnygaleirasShow" variant="outline-warning" class="float-right mb-2" v-b-modal.modal-3><b-icon-chat-text class="mr-1"></b-icon-chat-text>Anyag+kivitel súgó</b-button>
                        <b-modal id="modal-3" size="lg" title="Leírás">
                          <h3>{{anyagTipusSelect.tipus}}</h3>
                          <p class="my-4">{{anyagTipusSelect.megnevezes}}</p>
                          <p class="my-4">{{anyagTipusSelect.leiras}}</p>
                          <template #modal-footer="{ ok, cancel, hide }">
                            <b-button size="sm" variant="outline-danger" @click="cancel()">
                              Bezárás
                            </b-button>
                          </template>
                        </b-modal>
                      </th>
                      <th>Tétel hozzáadás</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width: 400px;">
                        <input type="text" class="form-control" v-model="myTempElements.tetelnev" id="tetelnev" required >
                      </td>
                      <td style="width: 150px;">
                        <input type="number" class="form-control" v-model="myTempElements.db" id="db" required >
                      </td>
                      <td>
                        <input type="number" class="form-control" v-model="myTempElements.cm1" id="cm1" required >
                      </td>
                      <td>
                        <input type="number" class="form-control" v-model="myTempElements.cm2" id="cm2" required >
                      </td>
                      <td style="width: 400px;">
                        <select v-model="anyagTipusSelect" class="form-control" id="anyagtipus" >
                          <option v-for="(anyagtipus) in anyagTipus" :key="anyagtipus.id" :value="anyagtipus">
                            {{ anyagtipus.tipus }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <button @click="addElement($event)" class="btn btn-primary mb-2">
                          <b-icon-plus-circle></b-icon-plus-circle>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div hidden>
                    <label for="anyagT">Anyag+kivitel</label>
                    <input type="text" class="form-control" v-model="anyagTipusSelect.tipus" id="anyagT" required>
                </div>
              </form>
            </div>

              <div class="row">

                <!-- // PAGE DETAILS ADD -->
                <div class="col-sm-12 mx-auto">
                  <table class="table mx-auto">
                    <thead>
                      <tr>
                        <th hidden class="tableformat">Anyag</th>
                        <th class="tableformat text-left">Azonosító (fájlnév)</th>
                        <th class="tableformat">Darab</th>
                        <th class="tableformat">Szélesség (x) cm</th>
                        <th class="tableformat">Magasság (y) cm</th>
                        <th class="tableformat text-right">m2</th>
                        <th>X</th>
                      </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(element, index) in myTetels" :key="element.id">
                      <td class="text-left" hidden>{{anyagTipusSelect.tipus}}</td>
                      <td>{{element.tetelnev}}</td>
                      <td>{{element.db}}</td>
                      <td>{{parseFloat(element.cm1, 1).toFixed(1)}}</td>
                      <td>{{parseFloat(element.cm2, 1).toFixed(1)}}</td>
                      <td class="text-right">{{parseFloat(element.m2, 2).toFixed(2)}}</td>
                      <td>
                        <b-button
                          size="sm"
                          variant="outline-danger"
                          @click="deleteTetel(myTetels, index)"
                          class="mr-1"
                        ><b-icon-trash></b-icon-trash>
                        </b-button>
                      </td>
                    </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colspan="3">Összeterület: </th>
                        <th class="text-right" colspan="2">{{parseFloat(osszterulet, 2).toFixed(2)}}</th>
                      </tr>
                    </tfoot>
                  </table>

                  <!-- SAVE CARD -->
                  <b-button @click="savePage" type="submit" class="btn btn-info mb-2 float-left">
                    <b-icon-cloud-upload></b-icon-cloud-upload>
                    Kártya mentése
                  </b-button>

                  <!-- CANCEL CARD -->
                  <b-button
                    variant="outline-danger"
                    class="float-right"
                    @click="AnyagPanelShow=false, MunkalapShow=true"
                    ><b-icon-arrow-left></b-icon-arrow-left>
                    Mégsem
                  </b-button>
                </div>

              </div>

        </b-card>
      </div>

      <!-- // ÚJ MUNKALAP -->
      <div v-show="MunkalapShow" class="col-sm-12 mt-3 mx-auto" style="bottom: 20px;">
        <b-card
          header
          border-variant="secondary"
          header-bg-variant="none"
          header-text-variant="white"
          header-border-variant="none"
          footer
          header-class="munkalapcardheader"
        >
          <template#header>
            <em>
              <table style="width:960px;" class="center">
                <tbody>
                  <tr>
                    <td>
                      <b-button
                        size="sm"
                        variant="primary"
                        class="float-left"
                        type="submit"
                        @click="mainDataButtonClick"
                        ><b-icon-plus-circle></b-icon-plus-circle>
                        Anyag + kivitel
                      </b-button>
                    </td>
                    <td>
                      <b-button
                        size="sm"
                        variant="outline-warning"
                        class="float-left"
                        v-b-modal.modal-1
                      ><b-icon-plus-circle></b-icon-plus-circle>
                      Egyéb tételek</b-button>
                    </td>
                    <!-- <td>
                      <b-button
                        size="sm"
                        variant="secondary"
                        class="float-left"
                        type="submit"
                        @click="nyomdaiMunkalapPanel"
                        ><b-icon-plus-circle></b-icon-plus-circle>
                        Nyomdai munkalap tétel
                      </b-button>
                    </td> -->
                    <td>
                      <!-- // SAVE -->
                      <b-button
                        size="sm"
                        variant="success"
                        class="float-right"
                        type="submit"
                        @click="saveWork"
                        ><b-icon-cloud-upload></b-icon-cloud-upload>
                        Munkalap mentése
                      </b-button>
                    </td>
                    <td>
                      <!-- // CANCEL -->
                      <!-- <b-button
                        size="sm"
                        variant="outline-danger"
                        class="float-right"
                        @click="
                          $router.push({
                            name: 'Munkak'
                          })
                        "
                        ><b-icon-arrow-left></b-icon-arrow-left>
                          Mégsem
                        </b-button>
                       -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </em>
          </template>

          <!-- MUNKALAP TABÁLÁZAT -->
          <div class="col-sm-12">
            <div class="row" v-for="(pageElement, index) in myTempAnyagTipus" :key="pageElement.id">
              <div class="col-md-12 mx-auto" hidden>
                <p>Anyag típus: {{pageElement.tipusName}}</p>
              </div>

              <div class="col-md-12">

                <table style="width:960px !important;" class="center pagedetail table-sm mt-1 ">
                  <!-- <thead>
                    <tr class="kompakt">
                      <td hidden >Anyag típus</td>
                      <td class=" text-left">Megnevezés (fájlnév)</td>
                      <td>Darab</td>
                      <td class=" text-right">Szélesség (x) cm</td>
                      <td class=" text-right">Magasság (y) cm</td>
                      <td class=" text-right">m2</td>
                      <td class=" text-right">Anyag + kivitel</td>
                      <td class=" text-right">Ár</td>
                    </tr>
                  </thead> -->
                  <tbody v-for="(pageTetel) in pageElement.tetels" :key="pageTetel.id">
                  <tr class="bordered">
                    <th></th>
                    <th style="width:300px !important;" class="text-left">{{pageTetel.tetelnev}}</th>
                    <th style="width:50px !important;" class="text-right">{{pageTetel.db}}</th>
                    <th style="width:50px !important;" class="text-right">{{parseFloat(pageTetel.cm1, 1).toFixed(1)}}</th>
                    <th style="width:50px !important;" class="text-right">{{parseFloat(pageTetel.cm2, 1).toFixed(1)}}</th>
                    <th style="width:50px !important;" class="text-right">{{parseFloat(pageTetel.m2, 2).toFixed(2)}}</th>
                    <th style="width:200px !important;"></th>
                    <th style="width:80px !important;"></th>
                  </tr>
                  </tbody>
                  <tfoot>
                    <tr class="footerrow">
                      <th style="width:70px !important;" class="text-right labelsize1 darkgray" colspan="1">
                        <!-- EDIT -->
                        <b-button
                          size="sm"
                          variant="outline-success"
                          class="btnmini mr-1 mb-2 float-left"
                          @click="editMaterial({page: pageElement})"
                        ><b-icon-pencil-fill></b-icon-pencil-fill>
                        </b-button>

                        <!-- DELETE -->
                        <b-button
                          size="sm"
                          variant="outline-danger float-left"
                          @click="$delete(myTempAnyagTipus, index)"
                          class="btnmini ml-2"
                        ><b-icon-trash></b-icon-trash>
                        </b-button>
                      </th>
                      <th style="width:300px !important;" class="text-right labelsize1 darkgray" colspan="4">
                        {{pageElement.megnevezes}}
                      </th>
                      <th style="width:100px !important;" class="text-right" colspan="1">{{parseFloat(pageElement.osszterulet, 2).toFixed(2)}}</th>
                      <td style="width:100px !important;" class="text-right" colspan="1">{{pageElement.tipusName}}</td>
                      <th style="width:100px !important;" class="text-right" colspan="1">
                        <input style="font-weight:bold; height: calc(1em + 0.5rem + 2px);" type="number" v-on="getVegOsszeg" @keyup="getVegOsszeg1"  v-model="pageElement.pageAr"  :key="pageElement.id" class="form-control text-right form-control-sm" id="ar" required>
                      </th>
                    </tr>
                    <tr class="table">
                      <td colspan="8"></td>
                    </tr>
                  </tfoot>
                </table>

              </div>

            </div>

            <!-- // EGYÉB TÉTEL -->
            <div v-if="myCikkTetels " v-show="EgyebTetelekShow">
              <table style="width:960px !important;"  class="table-sm mx-auto mt-1">
                <!-- <thead class="mx-auto">
                  <tr>
                    <td>DEL</td>
                    <td class="text-left">Megnevezés</td>
                    <td>Egység</td>
                    <td>Darab</td>
                    <td class="text-right">Nettó egységár</td>
                    <td class="text-right">Nettó összesen</td>
                  </tr>
                </thead> -->
                <tbody>
                  <tr v-for="(tetel, index) in myCikkTetels" :key="tetel.id">
                    <th style="width:60px !important;" colspan="1" >
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        @click="$delete(myCikkTetels, index)"
                        class="btnmini mr-1"
                      ><b-icon-trash></b-icon-trash>
                      </b-button>
                    </th>
                    <th style="width:270px !important;"  class="text-left">{{tetel.megnevezes}}</th>
                    <th style="width:50px !important;" >
                      <input type="number" v-model="tetel.db" @keyup="getVegOsszeg1" :key="tetel.id" class="form-control inputmini form-control-sm text-right" id="mennyiseg" required>
                    </th>
                    <th style="width:50px !important;" >{{tetel.mennyisegiegyseg}}</th>
                    <th style="width:50px !important;" ></th>
                    <td style="width:170px !important; font-size:smaller;"  class="text-right darkgray"></td>
                    <th style="width:170px !important; font-size:smaller;"  class="text-right">{{parseFloat(tetel.netto).toFixed(2) * parseFloat(tetel.db).toFixed(2)}}</th>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table">
                    <td colspan="8"></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- // MODAL EGYÉB TÉTEL -->
            <div>
              <b-modal id="modal-1" title="Egyéb tételek" >
                <div class="form-group" >
                  <label for="cikkek">Egyéb tételek hozzáadása</label>
                  <select v-model="cikkSelect" class="form-control" id="cikkek">
                    <option v-for="(cikkek) in cikkek" :key="cikkek.id" :value="cikkek">
                      {{ cikkek.megnevezes }}
                    </option>
                  </select>
                </div>
                <template #modal-footer>
                  <div class="w-100">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="float-right"
                      @click="addCikkTetel"
                    ><b-icon-plus-circle></b-icon-plus-circle>
                      Hozzáadás
                    </b-button>
                  </div>
                </template>
              </b-modal>
            </div>

          </div>

          <!-- // VÉGÖSSZEG -->
          <!-- <div class="col-sm-6 mx-auto">

            <div class="row">
              <div class="col-sm-4 mx-auto text-right">
                <p :prop="getVegOsszeg">Kalkulált végösszeg: </p>
              </div>
              <div class="col-sm-4 mx-auto">
                <p class="float-left">{{VegOsszeg}}</p>
              </div>
              <div class="col-sm-4 mx-auto">
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4 mx-auto text-right">
                <h3 :prop="getVegOsszeg">Végösszeg: </h3>
              </div>
              <div class="col-sm-4 mx-auto">
                <input id="vegosszeg1" class="form-control form-control-sm" type="number" v-model="VegSumOsszeg" >
              </div>
              <div class="col-sm-4 mx-auto">
                <b-button
                  size="sm"
                  variant="outline-info"
                  class="float-left"
                  type="submit"
                  @click="getVegOsszeg1"
                ><b-icon-arrow-clockwise></b-icon-arrow-clockwise>
                Újraszámolás
                </b-button>
              </div>
            </div>
          </div> -->

            <div>
              <table style="width:960px !important;" class="mx-auto">
              <!-- <table style="width:960px !important;" class=" table-bordered center mr-2"> -->
                <tbody>
                  <tr class="text-right darkgray" style=" font-size:smaller;">
                    <td  :prop="getVegOsszeg" >Számított végösszeg : </td>
                    <td style="padding-right: 10px; ">{{VegOsszeg}}</td>
                  </tr>
                  <tr class="text-right">
                    <td>
                      <h5 :prop="getVegOsszeg">Kiajánlott ár : </h5>
                    </td>
                    <td style="width:100px !important;">
                      <input style="font-weight:bold; height: calc(1em + 0.5rem + 2px);" id="vegosszeg1" class="form-control miniinput form-control-sm text-right" type="number" v-model="VegSumOsszeg" >
                    </td>
                    <!-- <td>
                      <b-button
                        size="sm"
                        variant="outline-info"
                        class="float-left"
                        type="submit"
                        @click="getVegOsszeg1"
                      ><b-icon-arrow-clockwise></b-icon-arrow-clockwise>
                      Újraszámolás
                      </b-button>
                    </td> -->
                  </tr>
                </tbody>
              </table>

            </div>

          <!-- FOOTER     -->
          <!-- <template #footer>
            <em>
              <div class="col-sm-12 mx-auto">
                <div>
                  // SAVE
                  <b-button
                  size="sm"
                    variant="success"
                    class="float-left"
                    type="submit"
                    @click="saveWork"
                    ><b-icon-cloud-upload></b-icon-cloud-upload>
                    Munkalap mentése
                  </b-button>

                  // CANCEL
                  <b-button
                  size="sm"
                    variant="outline-danger"
                    class="float-left ml-1"
                    @click="
                      $router.push({
                        name: 'Munkak'
                      })
                    "
                    ><b-icon-arrow-left></b-icon-arrow-left>
                      Mégsem
                    </b-button>

                </div>
              </div>
            </em>
          </template>               -->

        </b-card>
      </div>
    </div>

      <!-- <div class="row">
        <div class="col-sm-6 mx-auto">
          <p>erer</p>
        </div>
        <div class="col-sm-6 mx-auto">
          <p>erer</p>
        </div>
      </div>       -->

  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'
import axios from 'axios'
import router from '../router'

export default {
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      first_name: decoded.first_name,
      last_name: decoded.last_name,
      monogram: decoded.monogram,
      status: [],
      statusSelect: [],
      statusEditId: 0,
      partnerkategoriaSelected: null,
      partnerkategoria: [
        { value: 'A1', text: 'A1' },
        { value: 'VEA', text: 'VEA' },
        { value: 'BID', text: 'BID' },
        { value: 'TD', text: 'TD' },
        { value: 'K5', text: 'K5' },
        { value: 'K6', text: 'K6' },
        { value: 'K7', text: 'K7' },
        { value: 'K8', text: 'K8' },
        { value: 'K9', text: 'K9' },
        { value: 'K10', text: 'K10' }
      ],
      megjegyzes: '',
      anyagTipus: [],
      anyagTipusSelect: [],
      anyagTipusName: null,
      myTempAnyagTipus: [],
      ar: '',
      myTempElements: [
        {
          tipusid: '',
          tipusName: '',
          azonosito: '',
          tetelnev: '',
          db: '',
          cm1: '',
          cm2: '',
          m2: ''
        }
      ],
      myTetels: [],
      osszterulet: null,
      azonTemp: '',
      partner: '',
      emaillink: '',
      cikkek: [],
      cikkSelect: [],
      myCikkTetels: [],
      nyomdaiMunkalapPanelShow: false,
      AnyagPanelShow: false,
      EgyebTetelekShow: false,
      VegosszegShow: false,
      MunkalapShow: true,
      AnygaleirasShow: true,
      VegOsszeg: 0,
      VegSumOsszeg: 0,
      NettoOssz: null,
      client: {},
      pageEditorState: '',
      pageIndex: null,
      myNyomdaiMunkalapTelels: [
        {
          megnevezes: '',
          meret: '',
          terjedelem: '',
          papir: '',
          szin: '',
          koteszet: '',
          opcio: '',
          egyeb: '',
          mennyiseg: '',
          darabar: '',
          osszesen: ''
        }
      ]
    }
  },
  methods: {
    nyomdaiMunkalapPanel: function () {
      console.log('HI')
      this.nyomdaiMunkalapPanelShow = true
    },
    deleteTetel: function (req, index) {
      this.$delete(req, index)
      this.pageOsszeteruletCount()
    },
    deletePage: function (index) {
      // this.myTempAnyagTipus.splice(index, 1)
      this.$delete(this.myTempAnyagTipus, index)
    },
    editMaterial: function (req) {
      // ANYAG KICSERÉLÉSE PAGE EDITORBAN
      this.pageEditorState = 'EDIT'
      this.AnyagPanelShow = true
      this.MunkalapShow = false
      this.myTetels = req.page.tetels
      this.pageOsszeteruletCount()
      this.pageIndex = req.page.id
      for (var el in this.anyagTipus) {
        if (this.anyagTipus[el].id == req.page.tipusid) {
          this.anyagTipusSelect = this.anyagTipus[el]
        }
      }
    },
    getVegOsszeg1 () {
      let sum = 0
      let sumegyeb = 0
      this.myTempAnyagTipus.forEach(e => {
        sum += parseInt(e.pageAr)
      })
      this.myCikkTetels.forEach(e => {
        sumegyeb += parseInt(e.db * e.netto)
      })
      let result = this.VegSumOsszeg = sum + sumegyeb
      return result
    },
    pageOsszeteruletCount () {
      this.osszterulet = null
      for (var el in this.myTetels) {
        this.osszterulet += parseFloat(this.myTetels[el].m2)
        this.osszterulet.toFixed(2)
      }
    },
    addElement (event) {
      event.preventDefault()
      if (
        this.anyagTipusSelect.length !== 0 &&
        this.myTempElements.megnevezes !== '' &&
        this.myTempElements.db !== '' &&
        this.myTempElements.cm1 !== '' &&
        this.myTempElements.cm2
      ) {
        this.osszterulet = null
        let terulet = this.myTempElements.db * ((this.myTempElements.cm1 * this.myTempElements.cm2) / 100 / 100)

        this.myTetels.push(
          {
            tipusid: this.anyagTipusSelect.id,
            azonosito: this.azonTemp,
            tetelnev: this.myTempElements.tetelnev,
            db: this.myTempElements.db,
            cm1: parseFloat(this.myTempElements.cm1, 1).toFixed(1),
            cm2: parseFloat(this.myTempElements.cm2, 1).toFixed(1),
            m2: terulet.toFixed(2)
          }
        )
        this.pageOsszeteruletCount()
        this.myTempElements = []
      }
    },
    addCikkTetel: function () {
      this.myCikkTetels.push(
        {
          cikkid: this.cikkSelect.id,
          megnevezes: this.cikkSelect.megnevezes,
          mennyisegiegyseg: this.cikkSelect.mennyisegiegyseg,
          db: 0,
          netto: this.cikkSelect.netto,
          nettoosszesen: this.cikkSelect.netto
        }
      )
      this.EgyebTetelekShow = true
      this.VegosszegShow = true
      this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
    },
    saveWork: function () {
      if (
        this.statusSelect !== '' &&
        this.partner !== '' &&
        this.partnerkategoriaSelected != null
      ) {
        let payload = {}
        payload.id = this.$route.params.id
        payload.azonosito = this.azonTemp
        payload.statusid = this.statusSelect.id
        payload.partnerkategoria = this.partnerkategoriaSelected
        payload.partner = this.partner
        payload.emaillink = this.emaillink
        payload.megjegyzes = this.megjegyzes
        payload.kiallitotta = this.monogram
        payload.cikkTetels = this.myCikkTetels
        payload.pages = this.myTempAnyagTipus
        payload.szamitottVegOsszeg = this.VegOsszeg
        payload.VegOsszeg = this.VegSumOsszeg
        payload.token = this.token
        payload.userType = this.userType
        axios.post(process.env.ROOT_API + '/munkak/save', {payload}).then((res) => {
          console.log(res.data.id)
          this.$router.push({ name: 'Munkalap', params: { id: res.data.id }})
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    savePage: function (e) {
      let pageTempAr = null
      if (this.osszterulet >= 0 && this.osszterulet <= 0.124) {
        pageTempAr = this.anyagTipusSelect.ar1 * this.osszterulet
      } else if (this.osszterulet >= 0.125 && this.osszterulet <= 0.249) {
        pageTempAr = this.anyagTipusSelect.ar2 * this.osszterulet
      } else if (this.osszterulet >= 0.250 && this.osszterulet <= 0.499) {
        pageTempAr = this.anyagTipusSelect.ar3 * this.osszterulet
      } else if (this.osszterulet >= 0.500 && this.osszterulet <= 0.749) {
        pageTempAr = this.anyagTipusSelect.ar4 * this.osszterulet
      } else if (this.osszterulet >= 0.750 && this.osszterulet <= 0.999) {
        pageTempAr = this.anyagTipusSelect.ar5 * this.osszterulet
      } else if (this.osszterulet >= 1.000 && this.osszterulet <= 2.499) {
        pageTempAr = this.anyagTipusSelect.ar6 * this.osszterulet
      } else if (this.osszterulet >= 2.500 && this.osszterulet <= 4.999) {
        pageTempAr = this.anyagTipusSelect.ar7 * this.osszterulet
      } else if (this.osszterulet >= 5.000 && this.osszterulet <= 9.999) {
        pageTempAr = this.anyagTipusSelect.ar8 * this.osszterulet
      } else if (this.osszterulet >= 10.000 && this.osszterulet <= 19.999) {
        pageTempAr = this.anyagTipusSelect.ar9 * this.osszterulet
      } else if (this.osszterulet >= 20.000) {
        pageTempAr = this.anyagTipusSelect.ar10 * this.osszterulet
      }
      if (pageTempAr <= this.anyagTipusSelect.minimaldij) { pageTempAr = this.anyagTipusSelect.minimaldij }
      pageTempAr = parseFloat(pageTempAr, 0).toFixed(0)

      if (this.pageEditorState == 'EDIT') {
        for (var el in this.myTempAnyagTipus) {
          if (this.myTempAnyagTipus[el].id == this.pageIndex) {
            this.myTempAnyagTipus[el].azonosito = this.azonTemp,
            this.myTempAnyagTipus[el].osszterulet = parseFloat(this.osszterulet, 2).toFixed(2),
            this.myTempAnyagTipus[el].megnevezes = this.anyagTipusSelect.megnevezes,
            this.myTempAnyagTipus[el].pageTempAr = pageTempAr,
            this.myTempAnyagTipus[el].pageAr = pageTempAr,
            this.myTempAnyagTipus[el].tipusid = this.anyagTipusSelect.id,
            this.myTempAnyagTipus[el].tipusName = this.anyagTipusSelect.tipus,
            this.myTempAnyagTipus[el].tetels = this.myTetels
            this.osszterulet = 0
            this.myTetels = []
            this.anyagTipusSelect = []
            this.AnyagPanelShow = false
            this.VegosszegShow = true
            this.MunkalapShow = true
            this.getVegOsszeg1()
          }
        }
      } else {
        this.myTempAnyagTipus.push({
          azonosito: this.azonTemp,
          osszterulet: parseFloat(this.osszterulet, 2).toFixed(2),
          megnevezes: this.anyagTipusSelect.megnevezes,
          pageTempAr: pageTempAr,
          pageAr: pageTempAr,
          tipusid: this.anyagTipusSelect.id,
          tipusName: this.anyagTipusSelect.tipus,
          tetels: this.myTetels
        })
        this.osszterulet = 0
        this.myTetels = []
        this.anyagTipusSelect = []
        this.AnyagPanelShow = false
        this.VegosszegShow = true
        this.MunkalapShow = true
        this.getVegOsszeg1()
      }
    },
    categoryChange: function () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.filter = this.partnerkategoriaSelected
        payload.getHiddenList = true
        axios.post(process.env.ROOT_API + '/anyagtipus/getlist', { payload })
          .then((res) => {
            this.anyagTipus = res.data
          }).catch((err) => {
            console.log(err)
          })
      }
    },
    mainDataButtonClick: function () {
      if (
        this.statusSelect !== '' &&
        this.partner !== '' &&
        this.partnerkategoriaSelected != null
      ) {
        this.pageEditorState = ''
        this.MunkalapShow = false
        this.AnyagPanelShow = true
      }
    },
    focusInput () {
      this.$refs.MiniCRM.focus()
    }
  },
  computed: {
    getVegOsszeg: function () {
      let sum = 0
      let sumegyeb = 0
      this.myTempAnyagTipus.forEach(e => {
        sum += parseInt(e.pageAr)
      })
      this.myCikkTetels.forEach(e => {
        sumegyeb += parseInt(e.db * e.netto)
      })
      let result = this.VegOsszeg = sum + sumegyeb
    }
  },
  // watch: {
  //   anyagTipusSelect: function (val) {
  //     return this.anyagTipusName = val.tipus
  //   }
  // },
  mounted: function () {
    let id = this.$route.params.id
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      payload.id = id
      payload.token = this.token
      payload.userType = this.userType
      payload.filter = 'K0'
      payload.getHiddenList = true
      if (payload.id) {
        axios.post(process.env.ROOT_API + '/munkak/pdf', {payload})
          .then(res => {
            this.client = res.data.client
            this.myTempAnyagTipus = res.data.client.pages
            this.emaillink = this.client.emaillink
            this.megjegyzes = this.client.megjegyzes
            this.partner = this.client.partner
            this.partnerkategoriaSelected = this.client.partnerkategoria
            this.myCikkTetels = this.client.cikkTetels
            this.statusSelect = this.client.statusid
            this.VegSumOsszeg = res.data.client.VegOsszeg
            this.monogram = res.data.client.monogram
            if (this.client.cikkTetels.length > 0) {
              this.EgyebTetelekShow = true
            } else { this.EgyebTetelekShow = false }
            this.categoryChange()
          })
          .catch(err => {
            console.log(err)
          })
      }
      axios.post(process.env.ROOT_API + '/utils/getcode')
        .then((res) => {
          this.azonTemp = res.data
        }).catch((err) => {
          console.log(err)
        })
      this.partnerkategoriaSelected = 'A1'
      this.categoryChange()
      axios.post(process.env.ROOT_API + '/cikkek/getlist', { payload })
        .then((res) => {
          this.cikkek = res.data
        }).catch((err) => {
          console.log(err)
        })
      axios.post(process.env.ROOT_API + '/status/getlist', { payload })
        .then((res) => {
          for (var el in res.data) {
            this.status.push(
              {
                value: res.data[el],
                text: res.data[el].megnevezes
              })
          }
          this.statusSelect = res.data[0]
        }).catch((err) => {
          console.log(err)
        })
      this.focusInput()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Calculator.vue